<div class="pme-container">

  <div class="display-utils-row display-utils-center">
    <div class="pme-col display-utils-gt-sm-flex-50">
      <pme-hero *ngIf="this.showErrorHero" type="{{this.heroData.type}}" title="{{this.heroData.title}}"
        showButton="{{this.heroData.showButton}}" buttonName="{{this.heroData.buttonName}}"
        redirectURL="{{this.heroData.redirectURL}}">
        <p *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
      </pme-hero>
    </div>
  </div>

  <div *ngIf="this.showErrorHero === false && this.showForm" class="pme-row display-utils-col display-utils-gt-sm-row display-utils-center display-utils-gap-0 display-utils-gt-sm-gap-60">

    <div class="pme-col display-utils-gt-sm-flex-50" *ngIf="this.context !== 'RETENTION'">
      <aside>
        <h2 class="serasa-color-title display-utils-only-lt-md">{{this.heroData.title}}
        </h2>
        <p class="display-utils-only-lt-md" *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
        <pme-product-choice [cardTitle]="'Meu Pacote'" [productName]='this.currentPackage.name'
          [totalValue]="this.productValue" [productNameBold]="true" [shopWindowLink]="this.shopWindowLink">
        </pme-product-choice>
        <div class="change-plan display-utils-hide-lt-md" [ngClass]="{disabled: paymentFormSubmitting}">
          <mat-icon (click)="paymentFormSubmitting ? null : returnPage()">arrow_back</mat-icon>
          <p (click)="paymentFormSubmitting ? null : returnPage()">Voltar</p>
        </div>
      </aside>
    </div>
    <div class="pme-col display-utils-gt-sm-flex-50">
      <main>
        <h2 class="serasa-color-title display-utils-hide-lt-md">{{this.heroData.title}}
        </h2>
        <p class="display-utils-hide-lt-md" *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
        <pme-payment-form [context]="'AUTO_RECHARGE_PAYMENT_CHANGE'" (formSubmitted)="this.onSubmit($event)"
          [buttonName]="this.buttonName" [hideConditions]="false" [paymentOptions]="this.paymentOptions"
          [paymentChangeProduct]="this.currentPackage" [termOfUse]="this.tdu"
          [maxLimitCreditCards]="maxLimitCreditCards" (deleteCreditCard)="handleDeleteCreditCard($event)"
          [creditCardData]="this.creditCardData" [creditCardsData]="this.creditCardsData">
        </pme-payment-form>
      </main>
    </div>


  </div>
</div>